module.exports = __webpack_public_path__ + "d8cf1ae6c380f7426a3180fcf40f406d.svg";